declare let $2sxc: any;

import * as Hammer from 'hammerjs';
require('../scss/_Styles.scss');

export class MagazineApp {
  app: any;
  moduleId: number;
  currentId: string;
  currentUrl: string;
  currentPage: number;
  contNext: HTMLElement;
  contPrev: HTMLElement;
  mainUrl: string;
  prevUrl: string;
  nextUrl: string;
  prevPageId: number;
  nextPageId: number;
  loadingDelay = 500;
  reloadTimer = 60000;
  reloadPage = false;

  constructor(
    moduleId: number,
    editionId: string,
    editionPage: number,
    editionUrl: string
  ) {
    this.app = this;
    this.moduleId = moduleId;
    this.currentPage = editionPage;
    this.currentUrl = editionUrl;
    this.currentId = editionId;
    this.contNext = document.querySelector('.controls-next');
    this.contPrev = document.querySelector('.controls-prev');
  }

  public initialize() {
    window.addEventListener("popstate", event => {
      this.loadMagazinePage(event.state.page);
    })
    const magazinePaging = document.querySelectorAll('.magazine-page');
    this.mainUrl = (document.querySelector('.magazin-wrapper') as HTMLElement).dataset.pageurl;

    this.createControlUrls();

    this.adsRefreshHandling();

    this.contNext.addEventListener('click', event => {
      event.preventDefault();
      this.reloadPage ? '' : this.loading();

      this.createControlUrls();
      this.currentPage = this.nextPageId;
      this.setPushState(this.nextUrl);
    });

    this.contPrev.addEventListener('click', event => {
      event.preventDefault();
      this.reloadPage ? '' : this.loading();

      this.createControlUrls();
      this.currentPage = this.prevPageId;
      this.setPushState(this.prevUrl);
    })

    magazinePaging.forEach(el => el.addEventListener('click', event => {
      event.preventDefault();
      const elem = (event.currentTarget as HTMLElement);
      this.reloadPage ? '' : this.loading();
      
      this.currentPage = parseInt(elem.dataset.page);
      this.setPushState(elem.getAttribute('href'));
    }));

    var wrapperElem = document.getElementById('magazine-image-wrapper');
    var mc = new Hammer(wrapperElem);
    mc.on('swipeleft swiperight', this.onSwipe.bind(this.app));
    
    const pagination: HTMLElement = document.querySelector('.magazine-pagination');
    const pageLink: HTMLElement = document.querySelector('.magazine-page.active');
    pagination.scroll(pageLink.offsetLeft - pagination.offsetLeft, 0);

  }

  public adsRefreshHandling() {
    window.setTimeout(() => {
      this.reloadPage = true;
    }, this.reloadTimer)
  }

  public loading() {
    const pagesWrapper = document.querySelector('.pages');
    pagesWrapper.classList.add('loading');
  }

  public onSwipe(ev: any) {
    if(ev.type == 'swipeleft') {
      window.getComputedStyle(this.app.contNext.parentElement).display != 'none' ? this.app.contNext.click() : '';
    } else {
      window.getComputedStyle(this.app.contPrev.parentElement).display != 'none' ? this.app.contPrev.click() : '';
    }
  }

  public setPushState(url: string) {
    if(this.reloadPage) {
      window.location.href = url;
      return false;
    }

    const stateObj = { url: url, page: this.currentPage }
    window.history.pushState(stateObj, `Seite | ${this.currentPage}`, url);
    setTimeout(() => {
      this.loadMagazinePage(this.currentPage)
    }, this.loadingDelay)
  }

  public loadMagazinePage(page: number) {
    $2sxc(this.moduleId).webApi.get('app/auto/live/api/Magazine/GetPage', {id: this.currentId, pageNumber: page})
      .then((data: any) => {
        this.updateContent(data);
      }, () => {
        console.log("error")
      })
  }

  public createControlUrls() {
    const pageSkip = (window.innerWidth > 768 && this.currentPage != 1 ? 2 : 1)
    this.prevPageId = this.currentPage == 2 ? 1 : this.currentPage - pageSkip;
    this.nextPageId = this.currentPage + pageSkip;
    this.nextUrl = `${this.mainUrl}/nr/${this.currentId}/p/${this.nextPageId}/${this.currentUrl}`;
    this.prevUrl = `${this.mainUrl}/nr/${this.currentId}/p/${this.prevPageId}/${this.currentUrl}`;
  }

  public addLinks(data: any) {
    const magazineLinks = document.querySelector('.magazine-link-list');

    data.forEach((element: any) => {
      var a = document.createElement('a');
      a.href = element.Link;
      a.setAttribute('target', '_blank');
      a.innerHTML = `<span>${element.LinkText}</span> <i class="fas fa-camera-retro"></i>`
      magazineLinks.appendChild(a)
    });
  }

  public updateContent(content: any) {
    // console.log(content)
    const pageCount = (document.querySelector('.magazin-wrapper') as HTMLElement).dataset.pagecount;
    const contNext = this.contNext;
    const contPrev = this.contPrev;

    // CONTROLS NEXT
    contNext.setAttribute('href', this.nextUrl);
    contNext.parentElement.style.display = (this.currentPage == parseInt(pageCount) ? 'none' : 'block');

    // CONTROLS PREV
    contPrev.setAttribute('href', this.prevUrl);
    contPrev.parentElement.style.display = (this.currentPage == 1 ? 'none' : 'block');

    // IMAGE LINK
    const magazineImageLinkLeft: HTMLElement = document.querySelector('.left-page');
    if(magazineImageLinkLeft) {
      magazineImageLinkLeft.setAttribute('href', `${content.Page1.Image}?w=900&q=90`);
    }

    const magazineImageLinkRight: HTMLElement = document.querySelector('.right-page');
    if(magazineImageLinkRight) {
      magazineImageLinkRight.setAttribute('href', `${content.Page2.Image}?w=900&q=90`);
      if(this.currentPage == 1 || Object.keys(content.Page2).length == 0) {
        magazineImageLinkRight.classList.add('hide');
      } else {
        magazineImageLinkRight.classList.remove('hide');
      }
    }

    // IMAGE SRC
    const magazineImageLeft: HTMLImageElement = document.querySelector('.left-page .magazine-image');
    if(magazineImageLeft) {
      magazineImageLeft.src = `${content.Page1.Image}?w=450&q=90`;
    }
    const magazineImageRight: HTMLImageElement = document.querySelector('.right-page .magazine-image');
    if(magazineImageRight) {
      magazineImageRight.src = `${content.Page2.Image}?w=450&q=90`;
    }

    // MAGAZINE CONTENT
    const magazineContentLeft = document.querySelector('.magazine-content.left-page');
    if(content.Page1.Content) {
      magazineContentLeft.innerHTML = '';
      magazineContentLeft.innerHTML = content.Page1.Content;
    } else {
      magazineContentLeft.innerHTML = '';
    }

    const magazineContentRight = document.querySelector('.magazine-content.right-page');
    if(content.Page2.Content && this.currentPage != 1) {
      magazineContentRight.innerHTML = '';
      magazineContentRight.innerHTML = content.Page2.Content;
      magazineContentRight.classList.remove('hide')
    } else {
      magazineContentRight.innerHTML = '';
      magazineContentRight.classList.add('hide')
    }

    // MAGAZINE LINKS
    if(content.Page1.Links) {
      const magazineLinks = document.querySelector('.magazine-link-list');
      magazineLinks.innerHTML = '';
      this.addLinks(content.Page1.Links);
    }

    if(content.Page2.Links && this.currentPage != 1) {
      this.addLinks(content.Page2.Links);    
    }

    // PAGINATION MOBILE
    document.querySelectorAll('.magazine-page').forEach(el => el.classList.remove('active'));
    const pageLink: HTMLElement = document.querySelector(`.page-${this.currentPage}`);
    if(pageLink) {
      pageLink.classList.add('active');

      const pagination: HTMLElement = document.querySelector('.magazine-pagination');
      if(pagination) {
        pagination.scroll(pageLink.offsetLeft - pagination.offsetLeft, 0)
      }
    }

    // PAGINATION DESKTOP
    document.querySelectorAll('.magazine-page-desktop').forEach(el => el.classList.remove('active'));
    const pageLinkDesktop: HTMLElement = document.querySelector(`.magazine-page-desktop.page-${this.currentPage}`);
    if(pageLinkDesktop) {
      pageLinkDesktop.classList.add('active');

      const paginationDesktop: HTMLElement = document.querySelector('.magazine-pagination-desktop');
      if(paginationDesktop) {
        paginationDesktop.scroll(pageLinkDesktop.offsetLeft - paginationDesktop.offsetLeft - 75, 0)
      }
    }

    document.querySelectorAll('.page-edit').forEach(el => (el as HTMLElement).style.display = 'none');

    
    setTimeout(() => {
      const pagesWrapper = document.querySelector('.pages');
      pagesWrapper.classList.remove('loading');
    }, this.loadingDelay)    
  }
}